import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { CustomMailSettingDefault } from "@/components/features-new/custom-mail-setting";

import { useConfirmParams } from "../../email/hooks";

export const CustomMailSettingDefaultPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="基本メール設定" url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.TOP, { hotelID })}>
			<CustomMailSettingDefault hotelID={hotelID} />
		</PageMeta>
	);
};

CustomMailSettingDefaultPage.displayName = "CustomMailSettingDefaultPage";
